module.exports = __webpack_public_path__ + "static/media/Caminho-2.57602296.svg";